import React, { useState, useEffect } from 'react'
import { ToastContainer } from 'react-toastify'
import { useDispatch, useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import SingleContactDetails from './single-contact-details'
import { SolidButton, TransparentButton } from '../../../../library/button'
import { changeSingleListModal, requestAddNewContact, requestFetchContactLists, resetFetchContactLists } from '../../../../../redux/actions/single-list'
import { sendErrorNotification } from '../../../../universal/notifications/notifications'
import { auth } from '../../../../../networking/firebase'
import { Popup } from '../../../../library/popup'
import './style.scss'


const Index = () => {

    const dispatch = useDispatch()

    const addLoading = useSelector(state => state.singleList.addContact.loading)
    const modalState = useSelector(state => state.singleList.showModals.addContactModal)

	const activeDisplay = useSelector(state => state.singleList.activeDisplay)

	const fetchError = useSelector(state => state.singleList.fetchContactLists.error)

    const selectedCompany = useSelector(state => state && state.activeCompany && state.activeCompany.activeCompany && state.activeCompany.activeCompany.id)

	const [selectedContactList, setSelectedContactList] = useState(null)

    const [singleContact, setSingleContact] = useState({
        addedBy: auth.currentUser.uid,
		logoUrl: null,
		general: {
			firstName: null,
			lastName: null
		},
		contact: {
			phone: null,
			email: null,
			website: null
		},
        company:{
            name: null,
            position: null
        },
		social: {
			twitter: null,
			facebook: null
		},
		address: {
			street: null,
			postalCode: null,
			city: null,
			country: null
		},
    })

    const handleClose = () => {
        dispatch(changeSingleListModal({addContactModal: false}))
    }

    const clickAddContact = () => {
		if(selectedContactList){
			dispatch(requestAddNewContact({companyId: selectedCompany, contactList: selectedContactList, record: singleContact}))
		} else {
			sendErrorNotification("Du må velge en kontaktliste.")
		}
    }

	useEffect(() => {
		dispatch(resetFetchContactLists())
		dispatch(requestFetchContactLists({companyId: selectedCompany}))
		setSingleContact({
			general:{
				firstName: activeDisplay.general?.roles[0]?.name.split(' ')[0],
				lastName: activeDisplay.general?.roles[0]?.name.split(' ')[1]
			},
			company:{
				name: activeDisplay.general?.name,
				position: activeDisplay.general?.roles[0]?.role
			},
			address:{
				country: "NO",
				postalCode: activeDisplay.address?.postalCode,
				city: activeDisplay.address?.city,
				street: activeDisplay.address?.street
			},
			contact:{
				phone: activeDisplay.contact?.phone,
				email: activeDisplay.contact?.email,
				website: activeDisplay.contact?.website
			},
			social:{
				twitter: activeDisplay.social?.twitter,
				facebook: activeDisplay.social?.facebook
			}
		})
	}, [])

	useEffect(() => {
		if(fetchError){
			sendErrorNotification("Kunne ikke hente kontaktlister.")
			dispatch(resetFetchContactLists())
		}
	}, [fetchError])

	return(
		<Popup
			onClose={handleClose}
			show={modalState} 
			title="Legg til i kontaktliste"
			description="Legg til styrets- eller daglig leder for bedriften i en eksisterende kontaktliste du har."
			buttons={[
				<TransparentButton title="Avbryt" type="button" data-dismiss="modal" onClick={() => handleClose()} />,
				<SolidButton color="blue" title={addLoading ? "Legger til..":"Legg til"} onClick={() => clickAddContact()} icon={addLoading ? <i className="fas fa-circle-notch fa-spin"></i>:<i className="fas fa-plus"></i>} type="button"/>
			]}		
		>
			<div className="add-contact-content-container">
				<SingleContactDetails singleContact={singleContact} setSingleContact={setSingleContact} setSelectedContactList={setSelectedContactList}/>
			</div>
			<ToastContainer/>
		</Popup>
	)
}

export default withRouter(Index)